export class Cacheable {
    /**
     * Constructor detail
     * @param key
     * @param item
     * @param ts
     * @param maxAge
     */
    constructor(key, item, ts, maxAge) {
        /** @Override */
        this.error = false; // error occured when itm was last refreshed 
        this.key = key;
        this.item = item;
        this.ts = ts;
        this.maxAge = maxAge;
    }
}



//////////////////
// WEBPACK FOOTER
// ./src/plugins/lib/cache/cacheable.cls.ts
// module id = null
// module chunks = 